import getProp from '@f/get-prop'
import { getMetadataByTypeAndSlug } from './metadata'

const getSourceSetupOption = (state, option) =>
  getProp(`application.sourceSetup.${option}`, state)

export const getSourceSetupStep = (state) =>
  getSourceSetupOption(state, 'step')

export const getSourceSetupSlug = (state) =>
  getSourceSetupOption(state, 'sourceSlug')

export const getSourceSetupOauthError = (state) =>
  getSourceSetupOption(state, 'oauthError')

export const getSourceSetupSource = (state) =>
  getSourceSetupOption(state, 'source')

export const getSourceSetupSettings = (state) =>
  getSourceSetupSource(state).settings

export const isSourceSetupTestSuccessful = (state) =>
  getSourceSetupOption(state, 'isTestSuccessful')

export const isSourceSetupConnectSuccessful = (state) => {
  const oauthError = getSourceSetupOauthError(state)
  const settings = getSourceSetupSettings(state)
  return !oauthError && settings
}

export function getNextSourceSetupStep (state) {
  const currentStep = getSourceSetupStep(state)
  const sourceSlug = getSourceSetupSlug(state)
  const { data: sourceMetadata } = getMetadataByTypeAndSlug(state, 'source', sourceSlug) || {}
  let nextStep

  if (currentStep === 'connect') {
    if (getProp('features.accounts', sourceMetadata)) {
      nextStep = 'select-account'
    } else {
      nextStep = 'test-connection'
    }
  } else if (currentStep === 'select-account') {
    nextStep = 'test-connection'
  } else if (currentStep === 'test-connection') {
    nextStep = 'warehouse-config'
  } else if (currentStep === 'warehouse-config') {
    nextStep = 'connected'
  }

  return nextStep
}



// WEBPACK FOOTER //
// ./selectors/source-setup.js